module.exports = __webpack_public_path__ + "img/LqsImgLogin.b0518199.svg";